var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Darts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Darts",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_darts_777272_000000",
    transform: "translate(1.994553, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25488194,32.4034195 C5.74156328,32.7359093 6.23670785,32.495697 6.65123963,32.0810846 L14.8685569,24.9989343 L15.1048887,24.0355219 L23.7369941,15.1905253 L28.5497158,16.5805486 L37.0054465,8.71080901 C35.1888898,6.98426568 32.6313542,6.27523024 30.1857961,6.81603128 C30.7265589,4.36845408 30.0175634,1.81268591 28.2911526,0 L20.4219703,8.45017644 L21.8138947,13.2652388 L12.9654227,21.8979554 L12.0040781,22.134304 L4.91832756,30.3522031 C4.5017449,30.7688153 4.26582233,31.2120944 4.59828862,31.6968002 C1.42725955,35.1148174 -0.103687821,36.8825507 0.00544651356,37 C0.114580848,37.1174493 1.86439266,35.5852558 5.25488194,32.4034195 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03671559,35.1040649 C7.33375811,35.6116443 7.64018731,35.6443504 8.19995484,35.4492863 L18.7642026,32.63273 L19.3987196,31.8723469 L31.1087812,27.6544681 L34.8794137,30.9686723 L46.0054465,27.5489867 C45.104211,25.222078 43.0916136,23.4863235 40.6281399,22.9230428 C42.1901194,20.9623633 42.6609635,18.3687446 41.8809825,16 L31.0317039,20.1900562 L30.1991654,25.1046216 L18.3840925,29.039892 L17.4081074,28.8388506 L7.3771933,33.1582871 C6.8174775,33.3553487 6.62985373,33.5725756 6.72079462,34.1518059 C2.19428047,35.9010496 -0.0441688972,36.8504476 0.00544651356,37 C0.0550619243,37.1495524 2.39881828,36.517574 7.03671559,35.1040649 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarts);
export default ForwardRef;